@file:Suppress("TooGenericExceptionThrown")

package com.klantenstop.web.data.repos

import com.klantenstop.web.data.NetworkingConfig
import com.klantenstop.web.data.models.NetworkResponse
import com.klantenstop.web.data.models.domain.Status
import com.klantenstop.web.data.models.domain.toStatus
import com.klantenstop.web.data.models.dto.requests.status.InsertStatus
import com.klantenstop.web.data.models.dto.responses.ErrorResponse
import com.klantenstop.web.data.models.dto.responses.StatusDto
import com.klantenstop.web.data.postRequest

object StatusRepo {
    private val statusUrl = "${NetworkingConfig.baseUrl}/api/v1/statuses"

    suspend fun createNewStatus(companyStatus: InsertStatus): Status {
        val response: NetworkResponse<StatusDto, ErrorResponse> = postRequest(statusUrl, companyStatus)

        return when (response) {
            is NetworkResponse.Success -> response.body.toStatus()
            is NetworkResponse.ServerError -> {
                val errorMessage = response.body?.errorDescription ?: response.body?.error ?: "Server fout bij het aanmaken van status"
                throw Exception(errorMessage)
            }

            is NetworkResponse.NetworkError -> throw Exception("Netwerkfout: controleer je internetverbinding")
            is NetworkResponse.UnknownError -> throw Exception("Onbekende fout bij het aanmaken van status")
        }
    }
}
